import styled from '@emotion/styled';
import { Spacer } from '@travelnest/merlin.spacer';
import theme from '@travelnest/merlin.theme';
import * as React from 'react';
import { Radio } from './Radio';

export interface IRadioQuestionAnswers { [label: string]: any; }

interface IYesNoAnswers { 'Yes': true; 'No': false; }

export interface IRadioQuestionProps<T extends IRadioQuestionAnswers> {
	id: string;
	question: string;
	options: T;
	selected: T[keyof T] | undefined | null;
	onChange?: (name: string, value: any) => void;
	// In some contexts we need to tweak these values
	activeHighlightStyle?: { top?: number, left?: number };
	horizontalAlignment?: boolean;
}

export const YES_NO = {
	'Yes': true,
	'No': false,
};

const Wrapper = styled.div`
	.radio-question__question {
		padding-top: 20px;
	}
`;

const Fieldset = styled.fieldset`
	border: 0;
	`;

const HorizontalFieldset = styled.fieldset`
	border: 0;
	display: flex;
	flex-direction: row;
	padding: ${theme.layout.spacing.standard} 0
`;

export const YesNoRadioQuestion = (props: Omit<IRadioQuestionProps<IYesNoAnswers>, 'options'>) => {
	return <RadioQuestion {...props} options={YES_NO} />;
};

export const RadioQuestion = <T extends IRadioQuestionAnswers>(props: IRadioQuestionProps<T>) => {
	const { question, options, onChange, id, selected, horizontalAlignment } = props;

	const radioClickHandler = (_: boolean, name: string, value: any) => {
		if (onChange) {
			onChange(name, value);
		}
	};

	const radios = Object.entries(options).map(([l, v], idx) => {
		return (
			<div style={horizontalAlignment ? { padding: `${theme.layout.spacing.standard}` } : {}}>
				<Radio
					key={l}
					name={l}
					value={v}
					checked={selected === v}
					onChange={radioClickHandler}
					label={l}
					activeHighlightStyle={props.activeHighlightStyle}
				/>
				{idx !== Object.entries(options).length - 1 && <Spacer spacing="small" />}
			</div>
		);
	});

	return horizontalAlignment ? <Wrapper data-testid={id}>
		<div style={{ color: 'var(--colour-grey)' }}>{question}</div>
		<HorizontalFieldset>
			<Spacer spacing="small" />
			{radios}
		</HorizontalFieldset>
	</Wrapper>
		:
		<Wrapper data-testid={id}>
			<Fieldset>
				<div style={{ color: 'var(--colour-grey)' }}>{question}</div>
				<Spacer spacing="small" />
				{radios}
			</Fieldset>
		</Wrapper>;
};
